import React,{useState} from "react";

import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";


// Icons
import GTranslateIcon from '@mui/icons-material/GTranslate';
import LanguageIcon from '@mui/icons-material/Language';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';

// translation:
import { useTranslation } from 'react-i18next';


function TranslationButton({selLang,updateDirection}) {

  const { t, i18n } = useTranslation(),
        [anchorEl, setAnchorEl]    = useState(null),
        [currLang, setCurrentLang] = useState(""),
        open                       = Boolean(anchorEl);


    let handleBtnClick, 
        handleBtnClose;

    handleBtnClick = (oEvent) => {
        setAnchorEl(oEvent.currentTarget);
    };

    handleBtnClose = (oEvent) => {
        const sItemKey = oEvent.currentTarget.getAttribute('data-item-key');
        setAnchorEl(null);
        i18n.changeLanguage(sItemKey);

        updateDirection();
        
    };

    return(
        <Box>
        <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleBtnClick}
                direction={'ltr'}
                
                sx={{
                color:'rgba(0, 0, 0, 0.87)',
                border: 'none',
                padding:0,
                right:'inherit',
                width:'fit-content',
                height:'3rem',
                margin:'0.75rem',
                ':hover': {
                    color:'black',
                    background:'white'
                }
                }}>
                <LanguageIcon sx={{padding:0, margin: 1}}/>
                {t('lang.shortText')}
            </Button>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleBtnClose}
                slotProps={{
                list: {
                    'aria-labelledby': 'basic-button',
                },
                }}
            >
                <MenuItem data-item-key="ar" selected={selLang === 'ar' }  onClick={handleBtnClose}>العربيه</MenuItem>
                <MenuItem data-item-key="he" selected={selLang === 'he' } onClick={handleBtnClose} >עברית</MenuItem>
                <MenuItem data-item-key="en" selected={selLang === 'en' }  onClick={handleBtnClose}>English</MenuItem>
            </Menu>
        </Box>

    )
}

export default TranslationButton;